import {
  HttpRequest,
  HttpEvent,
  HttpInterceptorFn,
  HttpHandlerFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TokenService } from '../services/token.service';
import { ToastService } from '../services/toast.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const tokenService = inject(TokenService);
  const toastService = inject(ToastService);
  const router = inject(Router);

  if (request.params.get('ignorePrefix') === 'true') {
    const params = request.params.delete('ignorePrefix');
    const cleanRequest = request.clone({ params });
    return next(cleanRequest);
  }

  const token = tokenService.getToken();

  if (!token) {
    return next(request);
  }

  const authReq = request.clone({
    headers: request.headers.set('Authorization', `Bearer ${token}`),
  });

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        tokenService.clear();
        toastService.showWarnToast(
          'Sessão expirada',
          'Sua sessão expirou. Por favor, faça login novamente.',
        );
        router.navigate(['/login']);
      }
      return throwError(() => error);
    }),
  );
};
